/**
 * SWIST — Arama sonuçlarının kalan kısmını, temada belirlenen sırayla yükler.
 *
 * search-results.liquid ilk sayfayı yeniden sıralanmış olarak basar ve kalan ürün
 * id'lerini data-ids'e yazar. Kaydırdıkça sıradaki id'ler "id:1 OR id:2 ..." aramasıyla
 * aynı section'dan render edilip grid'e eklenir. Filtre değişince section yeniden
 * render edildiğinde data-position sunucudan 0 olarak geldiği için baştan başlar.
 */
const BATCH_SIZE = 24;

class SearchRankedLoader extends HTMLElement {
  /** @type {IntersectionObserver | undefined} */
  #observer;
  #loading = false;

  connectedCallback() {
    this.#observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.#loadNext();
      },
      { rootMargin: '600px' }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  get #ids() {
    return (this.dataset.ids || '').split(',').filter(Boolean);
  }

  get #grid() {
    return this.closest('results-list')?.querySelector('[ref="grid"]');
  }

  async #loadNext() {
    const ids = this.#ids;
    const position = Number(this.dataset.position || 0);
    const grid = this.#grid;

    if (this.#loading || position >= ids.length || !grid) return;
    this.#loading = true;

    const batch = ids.slice(position, position + BATCH_SIZE);
    const url = new URL(window.Theme?.routes?.search_url || '/search', window.location.origin);
    url.searchParams.set('q', batch.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('type', 'product');
    url.searchParams.set('section_id', this.dataset.sectionId || '');

    try {
      const response = await fetch(url);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const items = [...doc.querySelectorAll('[ref="grid"] > [ref="cards[]"]')].filter(
        (item) => !grid.querySelector(`[data-product-id="${item.getAttribute('data-product-id')}"]`)
      );

      // Section yeniden render edildiyse (filtre değişti) bu sonuçlar artık geçersiz
      if (!this.isConnected || this.#grid !== grid) return;

      grid.append(...items);
      items.forEach((item) => item.querySelectorAll('.card-gallery').forEach((gallery) => window.initCardGallery?.(gallery)));
      this.dataset.position = String(position + batch.length);
    } catch (error) {
      console.error('[search-ranked-loader]', error);
      return;
    } finally {
      this.#loading = false;
    }

    // Eklenen kartlar ekranı doldurmadıysa sıradakini hemen getir
    if (this.getBoundingClientRect().top < window.innerHeight + 600) this.#loadNext();
  }
}

if (!customElements.get('search-ranked-loader')) {
  customElements.define('search-ranked-loader', SearchRankedLoader);
}
